let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '订单编号',
        props: 'walletListNo',
        minWidth: 240,
    },
    // {
    //     label: '运营类别',
    //     props: 'isHostOperate',
    //     minWidth: 100,
    //     formatter: function formatter(row, column, cellValue, index) {
    //         // 做判断
    //         if (row.isHostOperate == '01') {
    //             return '代运营'
    //         }
    //         else if (row.isHostOperate == '02') {
    //             return '自运营'
    //         } {
    //             return ''
    //         }
    //     }
    // },
    {
        label: '创建时间',
        props: 'transactionCreateTime',
        minWidth: 200,
    },
    {
        label: '充电桩编号',
        props: 'pileCode',
        minWidth: 200,
    },
    {
        label: '用户名',
        props: 'mobile',
        minWidth: 200,
        tooltip: true,
    },
    {
        label: '支付状态',
        props: 'transactionStatusName',
        minWidth: 200,
    },
    {
        label: '支付渠道',
        props: 'transactionChannelName',
        minWidth: 120,
    },
    {
        label: '支付流水号',
        props: 'transactionId',
        minWidth: 300,
    },
    {
        label: '支付金额',
        props: 'actInExpAmount',
        minWidth: 120,
    },
];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: true,
    showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}
// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'id',
    editRouter: 'pileModelDetail',
};

// // 面包屑
pageConfig.listBreadCrumb = [{
    type: 'title',
    name: '首页',
},
    {
        type: 'title',
        name: '订单管理'
    }, ];

// 详情的面包屑
pageConfig.detailBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'router',
    name: '充电订单管理',
    router: 'orderManageList'
},
{
    type: 'title',
    name: '订单详情',
}];

export default pageConfig;
